import type { AxiosInstance } from 'axios'

export type GroupServiceCapabilities = {
  percentClient: AxiosInstance
}

export type Group = {
  id: string
  name: string
  description?: string
  memberCount?: number
  roleCount?: number
  createdAt: string
  updatedAt: string
}

export type GetGroupsProps = {
  page?: number
  pageSize?: number
  cursor?: string | null
  search?: string
}

export type CreateGroupProps = {
  name: string
  description?: string
}

export type GetGroupByIdProps = {
  id: string
}

export const GROUP_MEMBER_ROLES = ['member', 'maintainer', 'owner'] as const
export type GroupMemberRole = typeof GROUP_MEMBER_ROLES[number]

export type GroupMemberAccount = {
  type: 'account'
  id: string
  email: string
  fullName?: string | null
  role: GroupMemberRole
  addedAt: string
}

export type GroupMemberGroup = {
  type: 'group'
  id: string
  name: string
  role: GroupMemberRole
  addedAt: string
}

export type GroupMember = GroupMemberAccount | GroupMemberGroup

export type GetGroupMembersProps = {
  groupId: string
  page?: number
  pageSize?: number
  cursor?: string | null
  search?: string
}

export type EditGroupProps = {
  id: string
  name?: string
  description?: string | null
}

export type AddMembersProps = {
  groupId: string
  memberIds: string[]
  role?: GroupMemberRole
}

export type RemoveGroupMemberProps = {
  groupId: string
  memberId: string
}

export type ChangeGroupMemberRoleProps = {
  groupId: string
  memberId: string
  role: GroupMemberRole
}

export type GroupPermission =
  | 'can_view'
  | 'can_list_members'
  | 'can_add_member'
  | 'can_remove_member'
  | 'can_set_member_role'
  | 'can_edit'
  | 'can_delete'
